/**
 * The item billboards' atlas lookup (integration plan slice 2b): each
 * instance carries the column of its look in the pattern atlas, and the
 * vertex program narrows the quad's texture coordinates to that column. Used
 * by the billboards' colour material and by their `customDepthMaterial`, so
 * the cut-out shadow has the pattern's outline.
 */
export const billboardVertexHeader = 'attribute float abLook;uniform float abLooks;';

/** After `uv_vertex`: the map coordinates of this instance's column. */
export const billboardUv = `
#ifdef USE_MAP
vMapUv.x=(vMapUv.x+abLook)/abLooks;
#endif`;
